import { useState, useEffect } from 'react';

const Typewriter = ({ text, onComplete }) => {
  const [displayText, setDisplayText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const [isTyping, setIsTyping] = useState(false);
  const [blinkCount, setBlinkCount] = useState(0);

  useEffect(() => {
    if (blinkCount < 6) {
      const timer = setTimeout(() => {
        setShowCursor((p) => !p);
        setBlinkCount((p) => p + 1);
      }, 300);
      return () => clearTimeout(timer);
    }
    if (!isTyping && blinkCount >= 6) {
      setIsTyping(true);
      setShowCursor(true);
    }
  }, [blinkCount, isTyping]);

  useEffect(() => {
    if (!isTyping) return;
    if (displayText.length < text.length) {
      const timer = setTimeout(
        () => setDisplayText(text.slice(0, displayText.length + 1)),
        80
      );
      return () => clearTimeout(timer);
    } else {
      onComplete?.();
    }
  }, [displayText, text, isTyping, onComplete]);

  useEffect(() => {
    if (isTyping) {
      const interval = setInterval(() => setShowCursor((p) => !p), 530);
      return () => clearInterval(interval);
    }
  }, [isTyping]);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'baseline' }}>
      <span>{displayText}</span>
      <span
        style={{
          display: 'inline-block',
          width: 4,
          height: '0.85em',
          background: '#F2F2F2',
          marginLeft: 4,
          transform: 'translateY(0.05em)',
          opacity: showCursor ? 1 : 0,
          transition: 'opacity 0.1s',
        }}
      />
    </span>
  );
};

export default Typewriter;
